export abstract class HTTPError<Response = unknown> extends Error {
  public abstract unauthorized: boolean;
  public abstract message: string;
  public abstract response: Response | null;
}
